<template>
    <Pharmacy></Pharmacy>
    <PatientDME
        v-model:dmes="patientDetails.dmEs"
        :order-id="patientDetails.associatedTaskId"
        :patient-status="patientDetails.status"
        :is-referral="patientDetails.isReferral"
        :provider-id="patientDetails.providerId"
        v-model:patient-vendors="patientDetails.dmeVendors"
    ></PatientDME>
    <PatientSupply
        v-model:supplies="patientDetails.supplies"
        :order-id="patientDetails.associatedTaskId"
        :patient-status="patientDetails.status"
        :is-referral="patientDetails.isReferral"
        :provider-id="patientDetails.providerId"
    >
    </PatientSupply>
</template>

<script lang="ts" src="./PharmacyAndDME.ts"></script>
